module.exports = __webpack_public_path__ + "static/media/subscription_img.02054d8f.png";